/* eslint-disable */
// @ts-nocheck

import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';

import type * as Types from '@xing-com/crate-common-graphql-types';
export type UnfollowRecommendationPageMutationVariables = Types.Exact<{
  pageId: Types.Scalars['ID']['input'];
}>;

export type UnfollowRecommendationPageMutation = {
  __typename?: 'Mutation';
  contentPageUnfollow?: {
    __typename?: 'ContentPageMutationResult';
    success?:
      | {
          __typename?: 'ContentInsiderModule';
          globalId: string;
          interactions?: {
            __typename?: 'ContentPageInteractions';
            isFollowed: boolean;
          } | null;
        }
      | {
          __typename?: 'ContentInsiderPage';
          globalId: string;
          interactions?: {
            __typename?: 'ContentPageInteractions';
            isFollowed: boolean;
          } | null;
        }
      | {
          __typename?: 'ContentManagedInsiderPage';
          globalId: string;
          interactions?: {
            __typename?: 'ContentPageInteractions';
            isFollowed: boolean;
          } | null;
        }
      | {
          __typename?: 'ContentManagedPage';
          globalId: string;
          interactions?: {
            __typename?: 'ContentPageInteractions';
            isFollowed: boolean;
          } | null;
        }
      | {
          __typename?: 'ContentPage';
          globalId: string;
          interactions?: {
            __typename?: 'ContentPageInteractions';
            isFollowed: boolean;
          } | null;
        }
      | null;
    error?: {
      __typename?: 'ContentError';
      message?: string | null;
      description?: string | null;
      errors?: Array<string> | null;
    } | null;
  } | null;
};

export const UnfollowRecommendationPageDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UnfollowRecommendationPage' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'pageId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentPageUnfollow' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'pageId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'pageId' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'FollowUnfollowMutationResultFields',
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'FollowUnfollowMutationResultFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ContentPageMutationResult' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'success' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'globalId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'interactions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'isFollowed' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'error' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'message' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'errors' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UnfollowRecommendationPageMutation,
  UnfollowRecommendationPageMutationVariables
>;
